import type { ApiNewsResponse, ApiNewsSearchResponse } from '../../types/api';
import { apiFetch } from './client';

export type NewsAsset = 'crypto' | 'stock' | 'forex';

export function fetchNews(options: { asset?: NewsAsset; symbol?: string; limit?: number } = {}): Promise<ApiNewsResponse> {
  const params = new URLSearchParams();
  params.set('limit', String(options.limit ?? 20));
  if (options.asset) params.set('asset', options.asset);
  if (options.symbol?.trim()) params.set('symbol', options.symbol.trim().toUpperCase());

  return apiFetch<ApiNewsResponse>(`/api/news?${params.toString()}` as `/api/${string}`);
}

export function searchNews(query: string, options: { asset?: NewsAsset; limit?: number } = {}): Promise<ApiNewsSearchResponse> {
  const params = new URLSearchParams({ q: query.trim(), limit: String(options.limit ?? 20) });
  if (options.asset) params.set('asset', options.asset);
  return apiFetch<ApiNewsSearchResponse>(`/api/news/search?${params.toString()}` as `/api/${string}`);
}
